import { useEffect, useState } from "react";
import { Button, Collapse, Col, Row, Card } from "react-bootstrap"
import { COLLAPSE } from "../../constants/Common";
import useOnlineInfo from "../../hooks/useOnlineInfo";
import PlayerQuocChien from "./PlayerQuocChien";
import SettingQuanDoan from "./SettingQuanDoan";
import SettingSeaFood from "./SettingSeaFood";
import PlayerSellEquipments from "./PlayerSellEquipments";
import PlayerTrucLoc from "./PlayerTrucLoc";
const ExtendFunction = ({ playerId }) => {
    const { online } = useOnlineInfo(playerId);
    const [open, setOpen] = useState(COLLAPSE.ALL_CLOSE);
    const tooggleMenu = (newState) => {
        if (online == false) return;
        setOpen((prevState) => {
            if (prevState === newState) return COLLAPSE.ALL_CLOSE
            return newState
        })
    }
    useEffect(() => {
        if (online == false) {
            setOpen(COLLAPSE.ALL_CLOSE);
        }
    }, [online])

    return (
        <div className="mt-2">
            {/* Các button điều khiển */}
            <Row xs={2} sm={3} md={4} lg={4} className="align-items-start text-nowrap d-flex border-bottom">
                <Col className="align-items-start d-flex mb-2">
                    <Button onClick={() => tooggleMenu(COLLAPSE.HOAT_DONG)} size="sm"
                        variant={open === COLLAPSE.HOAT_DONG ? "primary" : "outline-primary"}
                    >
                        Hoạt Động
                    </Button>
                </Col>
                <Col className="align-items-start d-flex mb-2">
                    <Button onClick={() => tooggleMenu(COLLAPSE.FARM_TRANG_BI)} size="sm"
                        variant={open === COLLAPSE.FARM_TRANG_BI ? "primary" : "outline-primary"}
                    >
                        Cài đặt Quân Đoàn
                    </Button>
                </Col>
                <Col className="align-items-start d-flex mb-2">
                    <Button onClick={() => tooggleMenu(COLLAPSE.HAI_SAN)} size="sm"
                        variant={open === COLLAPSE.HAI_SAN ? "primary" : "outline-primary"}
                    >
                        Cài đặt Hải Sản
                    </Button>
                </Col>
                <Col className="align-items-start d-flex mb-2">
                    <Button onClick={() => tooggleMenu(COLLAPSE.SELL_EQUIPMENTS)} size="sm"
                        variant={open === COLLAPSE.SELL_EQUIPMENTS ? "primary" : "outline-primary"}
                    >
                        Bán Trang Bị
                    </Button>
                </Col>
            </Row>


            {/* Các Collapse */}
            <Collapse in={open === COLLAPSE.HOAT_DONG}>
                <div>
                    <Card className="mt-1">
                        <Card.Header> Trục Lộc</Card.Header>
                        <Card.Body>
                            <PlayerTrucLoc playerId={playerId}></PlayerTrucLoc>
                        </Card.Body>
                    </Card>
                    <Card className="mt-1">
                        <Card.Header> Quốc Chiến</Card.Header>
                        <Card.Body>
                            <PlayerQuocChien playerId={playerId}></PlayerQuocChien>
                        </Card.Body>
                    </Card>
                </div>
            </Collapse>
            <Collapse in={open === COLLAPSE.FARM_TRANG_BI}>
                <div>
                    <SettingQuanDoan playerId={playerId}></SettingQuanDoan>
                </div>
            </Collapse>
            <Collapse in={open === COLLAPSE.HAI_SAN}>
                <div>
                    <SettingSeaFood playerId={playerId}></SettingSeaFood>
                </div>
            </Collapse>
            <Collapse in={open === COLLAPSE.SELL_EQUIPMENTS}>
                <div>
                    <PlayerSellEquipments playerId={playerId}></PlayerSellEquipments>
                </div>
            </Collapse>
        </div>
    );
}

export default ExtendFunction
